import React from 'react';
import AdminNavigationBloomberg from './AdminNavigationBloomberg';

const AdminNavigation: React.FC = () => {
  return <AdminNavigationBloomberg />;
};

export default AdminNavigation;